export default __webpack_public_path__ + "static/media/640_private01-nl-mobile.c5ca4fe7.png";